import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 15.8c10.7 0 20.8 4.2 28.3 11.7 7.6 7.6 11.7 17.6 11.7 28.4s-4.2 20.8-11.7 28.4C120.8 91.8 110.7 96 100 96s-20.8-4.2-28.3-11.7C64.1 76.7 60 66.7 60 55.9s4.2-20.8 11.7-28.4C79.2 20 89.3 15.8 100 15.8zM100 2C70.2 2 46.1 26.1 46.1 55.9s24.1 53.9 53.9 53.9 53.9-24.1 53.9-53.9S129.8 2 100 2zm55.4 137.7c12.2 0 22.2 10 22.2 22.2s-10 22.2-22.2 22.2H44.6c-12.2 0-22.2-10-22.2-22.2s10-22.2 22.2-22.2h110.8zm0-13.8H44.6c-19.9 0-36.1 16.1-36.1 36S24.6 198 44.6 198h110.8c19.9 0 36.1-16.1 36.1-36.1-.1-19.9-16.2-36-36.1-36z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}